<div class="whole-container">
    <mat-spinner *ngIf="loading" class="loading-spinner" [diameter]="70"></mat-spinner>
    <div class="product-container generic-container">
        <div class="content">
            <div class="heading-container">
                <mat-icon class="icon" (click)="goBack()">arrow_back</mat-icon>
            </div>

            <div *ngIf="productDetail && productDetail.isActive">
                <div class="product-content">
                    <div class="product-detail-container">
                        <div class="product-image-content">
                            <app-block-details-component
                                [shapeJson]="shapeJson"
                                [selectedColor]="selectedColor"
                                [resetSelectedOption]="resetSelectedOption"
                                (faceColor)="getFaceColors($event)"
                                (seletedchoice)="getSeletedChoice($event)"
                                *ngIf="isCategoryBuyBlock"
                            ></app-block-details-component>
                            <app-product-image-gallery
                                [showWishlistIcon]="false"
                                [show360View]="true"
                                [productId]="productId"
                                class="product-image-gal"
                                *ngIf="!isCategoryBuyBlock"
                            ></app-product-image-gallery>
                        </div>
                        <div class="product-info">
                            <div>
                                <p class="product-name">
                                    {{ productDetail.name }}
                                    <span *ngIf="productDetail.modelQuantityJson && !productDetail.model3DJson">
                                        ({{ productDetail.modelQuantityJson.totalBlock }}
                                        {{ "productDetails.shape" | translate }})
                                    </span>
                                </p>
                                <div class="description-content">
                                    <p class="description">
                                        {{ productDetail.description }}
                                    </p>
                                </div>
                            </div>
                            <div class="rating-content" *ngIf="productDetail.averageRating">
                                <p class="rating" *ngIf="productDetail.averageRating">
                                    {{ productDetail.averageRating }}
                                    <mat-icon class="star">star</mat-icon>
                                </p>
                                &nbsp;
                                <span class="count-container" *ngIf="getTotalRatingsAndReviews().ratingCount">
                                    {{ getTotalRatingsAndReviews().ratingCount }}
                                    {{ "productDetails.rating" | translate }}
                                </span>
                            </div>

                            <div class="price-container">
                                <div>
                                    <span
                                        class="discounted-price"
                                        *ngIf="
                                            productDetail.discountedPrice &&
                                            productDetail.discountedPrice !== 0 &&
                                            productDetail.discountedPrice !== productDetail.price
                                        "
                                    >
                                        {{ "currency.rs" | translate }}
                                        {{ productDetail.discountedPrice }}
                                    </span>
                                    <span
                                        class="price"
                                        [ngClass]="{
                                            'cut-price':
                                                productDetail.discountedPrice &&
                                                productDetail.discountedPrice !== 0 &&
                                                productDetail.discountedPrice !== productDetail.price
                                        }"
                                    >
                                        {{ "currency.rs" | translate }} {{ productDetail.price }}
                                    </span>
                                    &nbsp;
                                    <span
                                        class="discount-percentage"
                                        *ngIf="
                                            productDetail.discountedPrice &&
                                            productDetail.discountedPrice !== productDetail.price
                                        "
                                        >{{ productDetail.discountPercentage }}%
                                        {{ "productOffer.off" | translate }}</span
                                    >
                                    <p class="text-color">
                                        {{ "productDetails.taxesMessage" | translate }}
                                    </p>
                                </div>

                                <div class="color-container" *ngIf="isCategoryBuyBlock">
                                    <h3>{{ "productDetails.selectColor" | translate }}</h3>
                                    <div class="color-content">
                                        <div *ngFor="let color of colors">
                                            <div
                                                class="color-box"
                                                [ngStyle]="{ 'background-color': color.value }"
                                                [class.active]="color.value === selectedColor"
                                                (click)="getSelectedColor(color.value)"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="btn-content">
                                <div *ngIf="!isCategoryBuyBlock">
                                    <div class="btn-first-row">
                                        <div class="add-btn-container" *ngIf="!isProductInCart">
                                            <app-button
                                                variant="hero"
                                                buttonClass="explore-btn"
                                                (onClick)="addToCart()"
                                                [disabled]="isLoading"
                                            >
                                                {{ "productDetails.button.productDetailAddBtn" | translate }}
                                            </app-button>
                                        </div>

                                        <div class="quantity-counter" *ngIf="isProductInCart">
                                            <button class="decrement" (click)="onClick(-1)">-</button>
                                            <input
                                                type="number"
                                                class="input-quantity"
                                                [(ngModel)]="quantity"
                                                (input)="onInputChange($event, productDetail)"
                                                (blur)="checkQuantity(productDetail)"
                                            />
                                            <button class="increment" (click)="onClick(1)" [disabled]="quantity >= 99">
                                                +
                                            </button>
                                        </div>

                                        <div class="wishlist-btn-container">
                                            <app-button
                                                [variant]="isInWishlist(productDetail) ? 'hero' : 'white'"
                                                buttonClass="explore-btn shadow-btn"
                                                (onClick)="toggleFavorite(productDetail)"
                                                [disabled]="isLoading"
                                            >
                                                {{
                                                    isInWishlist(productDetail)
                                                        ? ("productDetails.button.removeWishlist" | translate)
                                                        : ("productDetails.button.wishlist" | translate)
                                                }}
                                            </app-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="buy-block-btn-container" *ngIf="isCategoryBuyBlock">
                                    <div class="quantity-counter">
                                        <button class="decrement" (click)="onClick(-1)" [disabled]="quantity <= 1">
                                            -
                                        </button>
                                        <input
                                            type="number"
                                            class="input-quantity"
                                            [(ngModel)]="quantity"
                                            (input)="onInputChange($event, productDetail)"
                                            (blur)="checkQuantity(productDetail)"
                                        />
                                        <button class="increment" (click)="onClick(1)" [disabled]="quantity >= 99">
                                            +
                                        </button>
                                    </div>
                                    <div class="add-btn-container">
                                        <app-button
                                            variant="hero"
                                            buttonClass="explore-btn"
                                            (onClick)="addToCart()"
                                            [disabled]="isLoading"
                                        >
                                            {{ "productDetails.button.productDetailAddBtn" | translate }}
                                        </app-button>
                                    </div>
                                </div>
                                <div class="buy-btn-container">
                                    <app-button
                                        variant="hero"
                                        buttonClass="explore-btn"
                                        (onClick)="onClickBuy(productDetail.id, quantity, productDetail)"
                                        [disabled]="isLoading"
                                    >
                                        {{ "productDetails.button.buyProductBtn" | translate }}
                                    </app-button>
                                </div>
                            </div>

                            <div class="separator"></div>

                            <div class="delivery-section">
                                <div class="delivery-heading-container">
                                    <p class="delivery-heading">{{ "productDetails.deliveryOptions" | translate }}</p>
                                    <mat-icon class="truck-icon">local_shipping</mat-icon>
                                </div>

                                <div class="search-container">
                                    <app-search-bar
                                        [label]="'pincode'"
                                        [placeholder]="'Enter your pincode'"
                                        [prefixIcon]="'pin_drop'"
                                        [suffixWord]="'Check'"
                                        [pincode]="pinCode"
                                        [isPincodeInput]="true"
                                    >
                                    </app-search-bar>
                                </div>
                                <div>
                                    <p class="delivery-section-text">
                                        {{ "productDetails.getIt" | translate }}
                                        {{ deliveryDate | date: "EEE dd MMM yyyy" }}
                                    </p>
                                    <p class="delivery-section-text">{{ "productDetails.payOn" | translate }}</p>
                                    <p class="delivery-section-text">
                                        {{ "productDetails.easy&Days" | translate }}
                                    </p>
                                </div>
                            </div>

                            <div class="separator" *ngIf="!isCategoryBuyBlock"></div>

                            <div class="structure-link-section" *ngIf="!isCategoryBuyBlock">
                                <div class="structure-link-container">
                                    <p class="structure-link-heading">
                                        {{ "productDetails.structureDetails" | translate }}
                                    </p>
                                </div>
                                <div class="structure-link" (click)="goToStructure()">
                                    <p>{{ "productDetails.viewIn3DDesigner" | translate }}</p>
                                    <mat-icon class="link-icon">link</mat-icon>
                                </div>
                            </div>

                            <div class="separator"></div>

                            <div class="product-details-section">
                                <div class="product-details-container">
                                    <p class="description-heading">
                                        {{ "productDetails.productDetails" | translate }}
                                    </p>
                                    <mat-icon class="product-detail-icon">inventory</mat-icon>
                                </div>
                                <div class="specification-container">
                                    <div *ngFor="let spec of specifications" class="specification-item">
                                        <span>{{ spec.label }}</span>
                                        <span
                                            *ngIf="spec.label === SpecificationsLabel.TotalBlocks"
                                            class="specification-item-value"
                                        >
                                            {{ productDetail.modelQuantityJson?.totalBlock }}
                                        </span>
                                        <span *ngIf="!spec.isDynamic" class="specification-item-value">{{
                                            spec.value
                                        }}</span>
                                        <span
                                            *ngIf="spec.isDynamic"
                                            class="view-details specification-item-value"
                                            (click)="viewShapeCount()"
                                        >
                                            {{ spec.value | translate }}
                                        </span>
                                    </div>
                                    <div class="specification-item">
                                        <span>{{ "productDetails.quantity" | translate }}</span>
                                        <span class="specification-item-value">{{ quantity }}</span>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="separator"
                                *ngIf="ratingProducts.length && isReviewGreaterThan1(ratingProducts)"
                            ></div>

                            <div
                                class="user-review"
                                *ngIf="ratingProducts.length && isReviewGreaterThan1(ratingProducts)"
                            >
                                <div class="user-review-heading">
                                    <span class="user-review-heading-text">Customer Reviews</span>
                                    <span
                                        class="user-review-view-more"
                                        [routerLink]="['/products', productDetail.id, 'reviews']"
                                        >{{ "productDetails.viewMore" | translate }}</span
                                    >
                                </div>
                                <div class="reviews-section" *ngIf="productDetail.reviews">
                                    <div>
                                        <span class="user-review-rating-count-container"
                                            >{{ ratingProducts[0].rating }}
                                            <mat-icon class="user-review-star-icon">star</mat-icon></span
                                        >
                                    </div>
                                    <div class="user-review-container">
                                        <p>{{ ratingProducts[0].review }}</p>
                                        <p>
                                            {{ ratingProducts[0].name }}|
                                            {{ ratingProducts[0].createdAt | date: "dd MMM yyyy" }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="separator"></div> -->

                <div class="suggested-product-content" *ngIf="!isCategoryBuyBlock && suggestedProducts.length">
                    <p class="similar-product-heading">Similar Products:</p>

                    <div class="product-list" *ngIf="suggestedProducts.length > 0">
                        @for (product of suggestedProducts; track $index) {
                        <div class="animate-fade-in" [ngStyle]="{ 'animation-delay': $index * 0.05 + 's' }">
                            <app-product-card
                                [product]="product"
                                (isNavbarOpen)="setNavbarOpen($event)"
                            ></app-product-card>
                        </div>
                        }
                    </div>

                    <div class="right-navbar" *ngIf="isNavbarOpen">
                        <app-right-navbar (closeEvent)="onCloseNavbar()"></app-right-navbar>
                    </div>
                </div>
            </div>
        </div>

        @if (!loading && !productDetail) {
        <div class="product-not-found">
            <h2>{{ "productDetails.invalidMessage.productNotFound" | translate }}</h2>
            <p class="description">
                {{ "productDetails.invalidMessage.productNotFoundMessage" | translate }}
            </p>
            <app-button variant="hero" (click)="goToHome()">
                {{ "productDetails.button.goToHomeBtn" | translate }}
            </app-button>
        </div>
        } @if (!loading && productDetail && !productDetail.isActive) {
        <div class="product-not-found">
            <h2>{{ "productDetails.invalidMessage.outOfStock" | translate }}</h2>
            <p class="description">
                {{ "productDetails.invalidMessage.outOfStockMessage" | translate }}
            </p>
            <app-button variant="hero" (click)="goToHome()">
                {{ "productDetails.button.goToHomeBtn" | translate }}
            </app-button>
        </div>
        }
    </div>
</div>
